import React, { memo } from "react";
import { ROUTER_PATH } from "../../common/constant";
// import "./style.scss";
// import {  useParams } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import { localizeRouteKey } from "../../shared/helpers";
import "./style.scss";

const ProfileMenu = memo((props: any) => {
  // const { t } = useTranslation();
  // const url = location.pathname;
  // const { id } = useParams();

  const list = [
    {
      avt: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1623904229-Icontrangaccount-09.jpg",
      title: "Thông tin cá nhân",
      content:
        "Cập nhật các thông tin liên hệ, địa chỉ... hoặc thay đổi mật khẩu đăng nhập",
      path: ROUTER_PATH.PROFILE_DETAIL,
    },
    {
      avt: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1623904243-Icontrangaccount-06.jpg",
      title: "Quản lý đơn hàng",
      content: "Xem lại các đơn hàng đã đặt hoặc theo dõi tiếng độ đơn hàng",
      path: ROUTER_PATH.ORDERS,
    },
    // {
    //   avt: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1623904238-Icontrangaccount-07.jpg",
    //   title: "Tích điểm đổi quà",
    //   content:
    //     "Nhận điểm thưởng và các mã ưu đãi dành riêng cho khách hàng thân thiết",
    //   path: ROUTER_PATH.MEMBERSHIP,
    // },
    {
      avt: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1623904235-Icontrangaccount-08.jpg",
      title: "Danh sách yêu thích",
      content:
        "Bộ sưu tập các sản phẩm yêu thích và thông báo khi có ưu đãi dành riêng cho sản phẩm trong danh sách yêu thích",
      path: ROUTER_PATH.PRODUCTS_WISH,
    },
  ];

  const handleClick = (path: string) => {
    props.history.push(localizeRouteKey(path));
  };

  return list.map((item: any, i: number) => (
    <a
      key={i}
      className="kd-profile-menu-item"
      onClick={() => handleClick(item.path)}>
      <img src={item.avt} alt="" className="kd-profile-menu-item-image" />
      <span className="main-content kd-profile-menu-item-title">
        {item.title}
      </span>
      <span className="sub-content kd-profile-menu-item-content">
        {item.content}
      </span>
      <img
        src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/arrow-tail.svg"
        alt=""
        className="kd-profile-menu-item-arrow"
      />
    </a>
  ));
});

export default ProfileMenu;
